// extracted by mini-css-extract-plugin
export var searchHeader = "_74-0";
export var searchHeaderDark = "_74-1";